module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_OpenBox.5a50db75.png";